import { RouteProps } from '../../routes/AppRouter'
import { ClinicsDetail } from '../../features/clinics'
import { Title } from '../../components/common/Title'

export function Detail(props: RouteProps) {
  return (
    <>
      <Title color={props.color} title={props.title || ''} />
      <ClinicsDetail id={props.id} />
    </>
  )
}
